import React, { useState } from 'react';
import { NavBar } from '../kuroco/AppBars';
import { useSettingsData } from './useSettingsData';

const KIND = {
  goal: { label: '目標', cls: 'goal' },
  focus: { label: '注力指標', cls: 'focus' },
  action: { label: '行動プラン', cls: 'action' },
  init: { label: '初期設定', cls: 'init' },
};

const FILTERS = [
  { key: 'all', label: 'すべて' },
  { key: 'goal', label: '🎯 目標' },
  { key: 'focus', label: '🔁 注力指標' },
  { key: 'action', label: '✅ 行動プラン' },
];

export default function HistoryScreen() {
  const { D } = useSettingsData();
  const log = D.changeLog || [];
  const [filter, setFilter] = useState('all');

  const shown = log.filter(
    (e) => filter === 'all' || e.kind === filter || (filter !== 'all' && e.kind === 'init')
  );

  return (
    <div className="app">
      <NavBar title="変更履歴" backLabel="設定" backTo="/settings" hideSettings />

      <div className="hist-filter">
        {FILTERS.map((f) => (
          <button key={f.key} type="button" className={`hist-chip${filter === f.key ? ' is-on' : ''}`} onClick={() => setFilter(f.key)}>
            {f.label}
          </button>
        ))}
      </div>

      <div className="scroll fade" style={{ paddingTop: 14 }}>
        <div className="hist-intro">目標・注力指標・行動プランの変更を記録しています。変更は予測とロードマップに反映されます。</div>

        {shown.length === 0 ? (
          <div style={{ padding: '24px 20px', textAlign: 'center', color: 'var(--muted)', fontSize: '13px' }}>
            変更履歴はまだありません
          </div>
        ) : (
          <div className="hist-timeline">
            {shown.map((e, i) => (
              <div className="hist-item" key={`${e.date}-${e.title}-${i}`}>
                <div className="hist-rail">
                  <span className={`hist-dot hist-dot--${KIND[e.kind]?.cls || 'goal'}`}>{e.icon}</span>
                  {i < shown.length - 1 && <span className="hist-line" />}
                </div>
                <div className="hist-card">
                  <div className="hist-card-head">
                    <span className={`hist-tag hist-tag--${KIND[e.kind]?.cls || 'goal'}`}>{KIND[e.kind]?.label || '変更'}</span>
                    <span className="hist-date">
                      {e.date}（{e.day}）
                    </span>
                  </div>
                  <div className="hist-title">{e.title}</div>
                  <div className="hist-changes">
                    {(e.changes || []).map((c, j) => (
                      <div className="hist-change" key={j}>
                        <span className="hist-field">{c.field}</span>
                        <div className="hist-delta">
                          {c.type === 'init' || c.type === 'add' || c.before == null ? (
                            <span className="hist-after hist-after--new">{c.after}</span>
                          ) : (
                            <>
                              <span className="hist-before">{c.before}</span>
                              <svg className="hist-arrow" viewBox="0 0 16 10" fill="none" aria-hidden="true">
                                <path
                                  d="M1 5h13M10 1l4 4-4 4"
                                  stroke="currentColor"
                                  strokeWidth="1.6"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                              <span className="hist-after">{c.after}</span>
                            </>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="hist-by">
                    <span className="hist-by-ic">{e.kind === 'init' ? '🌱' : e.by?.includes('AI') ? '🤖' : '👤'}</span>
                    {e.by}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        <div className="hist-end">これ以前の変更はありません</div>
      </div>
    </div>
  );
}
